import { getUserRegion } from 'helpers/userStorage';

export function getDollarValue(val, showCurrency) {
    //var region = getUserRegion();

    return formatCurrencyForRegion(`${(val / 100).toFixed(2)}`, showCurrency);
}

export function formatCurrencyForRegion(value, showCurrency) {
    var region = getUserRegion();
    return `${region === 'EUR' ? '€ ' : '$'}${value}${showCurrency && region !== 'EUR' ? region : ''}`;
}


// WEBPACK FOOTER //
// ./src/helpers/dollarHelpers.js